import React, { useEffect, useState, Component } from 'react';
import { Box, Alert, AlertTitle, IconButton, Snackbar, Slide, SlideProps } from '@mui/material';
import { Icon } from '@iconify/react';
export type ToastType = 'success' | 'error' | 'warning' | 'info';
export interface ToastProps {
  open: boolean;
  message: string;
  title?: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}
function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="left" data-id="element-2877" data-mp="1p2d2m6l5sj37" />;
}
const Toast: React.FC<ToastProps> = ({
  open,
  message,
  title,
  type = 'success',
  duration = 4000,
  onClose
}) => {
  const [isOpen, setIsOpen] = useState(open);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
    onClose();
  };
  const iconMap = {
    success: 'lucide:check-circle',
    error: 'lucide:x-circle',
    warning: 'lucide:alert-triangle',
    info: 'lucide:info'
  };
  return <Snackbar open={isOpen} autoHideDuration={duration} onClose={handleClose} anchorOrigin={{
    vertical: 'top',
    horizontal: 'right'
  }} TransitionComponent={SlideTransition} sx={{
    maxWidth: '400px',
    '& .MuiPaper-root': {
      width: '100%'
    }
  }} data-id="element-2878" data-mp="dlnkkzers2sh">
      <Alert severity={type} variant="filled" sx={{
      width: '100%',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      borderRadius: '12px',
      alignItems: 'center',
      '&.MuiAlert-filledSuccess': {
        background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)'
      },
      '&.MuiAlert-filledError': {
        background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)'
      },
      '&.MuiAlert-filledWarning': {
        background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)'
      },
      '&.MuiAlert-filledInfo': {
        background: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)'
      }
    }} icon={<Icon icon={iconMap[type]} width={24} height={24} style={{
      color: 'white'
    }} data-id="element-2880" data-mp="3q4w9zrby0di4" />} action={<IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} data-id="element-2881" data-mp="2xg77poz5i24s">
            <Icon icon="lucide:x" width={16} height={16} data-id="element-2882" data-mp="2tfx4gk2qtptm" />
          </IconButton>} data-id="element-2879" data-mp="3qv1sgng6v9zr">
        {title && <AlertTitle sx={{
        fontWeight: 600
      }} data-id="element-2883" data-mp="377bomu8dzx29">
            {title}
          </AlertTitle>}
        {message}
      </Alert>
    </Snackbar>;
};
export default Toast;